import React from 'react'

import { Modal, Table, Button } from '_zari/core'

import * as StockService from 'services/stock.service'

const StockSedesModal = ({ handleClose, show, idProductoPresentacion }) => {
  const [stocks, setStocks] = React.useState([])

  React.useEffect(() => {
    StockService.obtenerStockEnSedes(idProductoPresentacion)
      .then(({ data }) => {
        setStocks(data || [])
      })
      .catch(() => {
        setStocks([])
      })
  }, [idProductoPresentacion])

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>STOCKS EN SEDES</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table
          filas={stocks}
          headRows={[{ label: 'ESTABLECIMIENTO' }, { label: 'CANTIDAD' }]}
          rowTemplate={(row, k) => (
            <Table.Row hover key={k}>
              <Table.Cell>{row.sede}</Table.Cell>
              <Table.Cell>{row.cantidad}</Table.Cell>
            </Table.Row>
          )}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(StockSedesModal)
